/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';


export interface GetBipPdf$Params {
  patientID?: number;
  bipID?: number;
}

export function GetBipPdf(http: HttpClient, rootUrl: string, params?: GetBipPdf$Params, context?: HttpContext): Observable<StrictHttpResponse<Blob>> {
  const rb = new RequestBuilder(rootUrl, GetBipPdf.PATH, 'get');
  if (params) {
    rb.query('patientID', params.patientID, {});
    rb.query('bipID', params.bipID, {});
  }

  return http.request(
    rb.build({ responseType: 'blob', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Blob>;
    })
  );
}

GetBipPdf.PATH = '/api/Staff/GetBipPdf';
